import React, { useState, useEffect } from "react";
import { Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";



const CloseQut = (props) => {
    const [Mode, setMode] = useState('');
    const [PODStatus, setPODStatus] = useState('');
    const [PODRemarks, setPODRemarks] = useState('');
    const [PODUpdatedByID, setPODUpdatedByID] = useState(sessionStorage.UserName);
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();


    const validationSchema = Yup.object({
        PODStatus: Yup.string().required('Required!'),
        PODRemarks: Yup.string().required('Required!'),
    });

    const onSubmit = () => {
        // setMode("Insert")
        var PODUpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        debugger;
        bodyFormData.append("DeliveryChallanID", props.DeliveryChallanID);
        bodyFormData.append("PODStatus", PODStatus);
        bodyFormData.append("PODRemarks", PODRemarks);
        bodyFormData.append("PODUpdatedByID", PODUpdatedByID);
        fetchData("DeliveryChallan/PODSave", bodyFormData);
    }

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("DeliveryChallanID", props.DeliveryChallanID);
        fetchGetData("DeliveryChallan/GetByID", bodyFormData);
    }

    useEffect(() => {
        // debugger;
        if ((response.Response === true)) {
            if (response.Message.includes('Closed') === true) {
                alert(response.Message);
            }
            else {
                alert(response.Message);
            }
            props.setPODOpen(false);
            props.PopulateData();
        }
        else if (response.Response === false) {
            alert('Failed.');
        }
    }, [response])



    useEffect(() => {
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setPODStatus(responseGetData[0].PODStatus);
            setPODRemarks(responseGetData[0].PODRemarks);
            // setPODUpdatedByID(responseGetData[0].PODUpdatedByID);
        }
    }, [responseGetData]);

    useEffect(() => {
        if (props.DeliveryChallanID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{
                PODStatus: PODStatus, PODRemarks: PODRemarks, PODUpdatedByID: PODUpdatedByID
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={5}>
                                <label htmlFor={"PODStatus"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"PODStatus"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='PODStatus'
                                    onChange={(e) => setPODStatus(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <label
                                    htmlFor={"PODRemarks"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"PODRemarks"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='PODRemarks'
                                    onChange={(e) => setPODRemarks(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <label
                                    htmlFor={"PODUpdatedBy"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"PODUpdatedBy"}
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    name='PODUpdatedByID'
                                    disabled={true}
                                // onChange={(e) => setAWBNumber(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setPODOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
};

export default CloseQut;
